import Button, {
	GradientGrayscaleButton,
} from "@/comps/button"
import { CustomThemedResource } from "@/comps/image"

import {
	getAdvancedButtonText,
	getBasicButtonText,
	getCurrentPackId,
} from "@/comps/subscription-popup"
import { useAdjustLogger } from "@/utils/adjust"
import useAuth from "@/utils/client-auth"
import clsx from "clsx"
import { useTranslation } from "next-i18next"
import { Package } from "pages/api/pricing-packs"
import { PlansType, Variant } from "./pricing-or-coin"

interface RenderBlockProps {
	plans: PlansType
	isYearly: boolean
	handlePurchaseClick: (packId: string) => void
	basic: Package
	advanced: Package
}

export default function RenderBlock(
	props: RenderBlockProps,
) {
	const {
		basic,
		advanced,
		isYearly,
		handlePurchaseClick,
		plans,
	} = props

	const { t } = useTranslation()

	const { userInfo } = useAuth()
	const logAdjust = useAdjustLogger()

	const { packId: currentPackId } = getCurrentPackId(
		userInfo.entitlements,
	)

	const yearlyPricePro =
		basic.variants[0].periods.find(
			(a) => a.period === "yearly",
		)?.price || 0
	const yearlyPriceDividedPro = yearlyPricePro / 12
	const yearlyPriceFormattedPro = Math.floor(
		yearlyPriceDividedPro,
	)

	const yearlyPriceAdvanced =
		advanced.variants[0].periods.find(
			(a) => a.period === "yearly",
		)?.price || 0
	const yearlyPriceDividedAdvanced =
		yearlyPriceAdvanced / 12
	const yearlyPriceFormattedAdvanced = Math.floor(
		yearlyPriceDividedAdvanced,
	)

	return (
		<div className="mt-10 flex w-full flex-col items-center justify-center gap-6 px-4 tablet:px-5 desktop:flex-row desktop:gap-[27px]">
			{/* Free Plan */}

			{/* <div
            className={clsx(
              "flex w-full flex-col overflow-hidden rounded-[8px] border border-color-separator",
              "tablet:flex-row desktop:h-[468px] desktop:w-[310px] desktop:flex-col",
              "[box-shadow:0px_5px_12px_0px_rgba(183,183,183,0.2)] dark:[box-shadow:unset]",
            )}>
            <div className="bg-color-surface-cell flex w-full flex-1 flex-col justify-between p-[18px]">
              <div className="flex flex-col">
                <p className="text-[24px] font-600 text-blue-900">
                  {t("txt_just_try")}
                </p>
                <p className="font-300 text-[14px] text-blue-600">
                  {t("txt_free_subtitle")}
                </p>
                <p className="mt-1 text-[32px] font-800 uppercase text-blue-800 tablet:text-[36px] desktop:mt-4 desktop:text-[32px]">
                  {t("txt_free")}
                </p>
              </div>
              <div className="mt-4 flex w-full tablet:mt-9 desktop:mt-0">
                <Button
                  outlineSecondary
                  href="/chat"
                  className={clsx(
                    "w-full !font-500",
                    currentPlan.id !== "free" &&
                      "pointer-events-none !cursor-not-allowed !border-green-100 !text-green-200",
                  )}
                  text="txt_get_started"></Button>
              </div>
            </div>
            <div className="h-[1px] w-full bg-blue-100 tablet:h-full tablet:w-[1px] desktop:h-[1px] desktop:w-full" />
            <div className="flex flex-col gap-2 bg-blue-50 p-4 tablet:w-[310px] tablet:gap-4 desktop:h-[160px] desktop:w-full desktop:gap-1">
              {plans.free.points.map((point) => {
                return (
                  <div
                    className="flex items-center gap-[10px] "
                    key={point}>
                    <CustomThemedResource
                      format="svg"
                      source="/pricing/check"
                    />
                    <span className="text-[14px] font-400 text-blue-800">
                      {point}
                    </span>
                  </div>
                )
              })}
            </div>
          </div> */}

			{/*PRIME */}

			<div
				className={clsx(
					"flex w-full flex-col overflow-hidden rounded-[8px] border-2 border-color-separator",
					"tablet:flex-row desktop:h-[468px] desktop:w-[310px] desktop:flex-col",
				)}>
				<div className="flex w-full flex-1 flex-col justify-between bg-color-surface-cell p-[18px]">
					<div className="flex flex-col">
						<p className="text-[24px] font-600 text-blue-900">
							{"Pro + AI"}
						</p>
						<p className="font-300 text-[14px] text-blue-600">
							{"For pro video creation"}
						</p>
						<div className="relative mt-3 h-[50px] w-full overflow-hidden">
							<div
								className={clsx(
									"absolute inset-0",
									"flex h-[50px] w-full flex-row items-end justify-start gap-[2px]",
									isYearly && "-top-16",
									"transition-all duration-500",
								)}>
								<span
									className={clsx(
										"font-700 text-blue-900",
										"text-[38px]",
									)}>
									$
									{String(
										basic.variants[0].periods.find(
											(a) => a.period === "monthly",
										)?.price,
									).slice(0, -2)}
									.
									<small>
										{String(
											basic.variants[0].periods.find(
												(a) => a.period === "monthly",
											)?.price,
										).slice(-2)}
									</small>
								</span>
								<span className="font-300 mb-[10px] text-[14px] lowercase text-blue-600">
									/{t("txt_month")}
								</span>
							</div>

							<div
								className={clsx(
									"absolute inset-0",
									"flex h-[50px] w-full flex-row items-end justify-start gap-[2px]",
									!isYearly && "top-16",
									"transition-all duration-500",
								)}>
								<span
									className={clsx(
										"font-700 text-blue-900",
										"text-[38px]",
									)}>
									$
									{String(yearlyPriceFormattedPro).slice(
										0,
										-2,
									).length !== 0
										? String(yearlyPriceFormattedPro).slice(
												0,
												-2,
										  )
										: 0}
									.
									<small>
										{String(yearlyPriceFormattedPro).slice(
											-2,
										)}
									</small>
								</span>
								<span className="font-300 mb-[10px] text-[14px] lowercase text-blue-600">
									/{t("txt_month")}*
								</span>
							</div>
						</div>
					</div>

					<div className="flex w-full">
						<GradientGrayscaleButton
							grayscale
							disabled={
								getBasicButtonText(currentPackId) ===
								"txt_current_plan"
							}
							onClick={() =>
								handlePurchaseClick(
									basic.variants[0].pack_id,
								)
							}
							className="flex h-[52px] w-full items-center justify-center !font-500 disabled:!text-color-inactive-text"
							text={getBasicButtonText(currentPackId)}
						/>
					</div>
				</div>
				<div className="h-[1px] w-full bg-blue-100 tablet:h-full tablet:w-[1px] desktop:h-[1px] desktop:w-full" />
				<div className="flex flex-col gap-2 bg-blue-50 p-4 tablet:w-[310px] tablet:gap-4 desktop:h-[160px] desktop:w-full desktop:gap-1">
					{plans.basic.points.map((point) => {
						return (
							<div
								className="flex items-center gap-[10px] "
								key={point}>
								<CustomThemedResource
									format="svg"
									source="/pricing/check"
								/>
								<span className="text-[14px] font-400 text-blue-800">
									{point}
								</span>
							</div>
						)
					})}
				</div>
			</div>

			{/* Enterprise */}

			<div
				className={clsx(
					"relative flex w-full flex-col rounded-[10px]",
					"tablet:flex-row desktop:h-[464px] desktop:w-[310px] desktop:flex-col",
				)}>
				<div
					style={{
						background:
							"linear-gradient(120deg, rgba(134, 54, 248, 1), rgba(240, 32, 179, 1), rgba(248, 71, 94, 1), rgba(255, 148, 33, 1) )",
					}}
					className="absolute left-[-2px] top-[-2px] h-[calc(100%+4px)] w-[calc(100%+4px)] rounded-[10px]"></div>

				<div className="z-10 flex w-full flex-1 flex-col justify-between rounded-t-[8px] bg-color-surface-cell  p-[18px] tablet:rounded-l-[8px] tablet:rounded-r-[0px] desktop:rounded-b-[0px] desktop:rounded-t-[8px]">
					<div className="flex flex-col">
						<p className="text-[24px] font-600 text-blue-900">
							{"Advanced + AI"}
						</p>
						<p className="font-300 text-[14px] text-blue-600">
							{t("txt_pro_subtitle")}
						</p>
						<div className="relative mt-3 h-[50px] w-full overflow-hidden">
							<div
								className={clsx(
									"absolute inset-0",
									"flex h-[50px] w-full flex-row items-end justify-start gap-[2px]",
									isYearly && "-top-16",
									"transition-all duration-500",
								)}>
								<span
									className={clsx(
										"font-700 text-blue-900",
										"text-[38px]",
									)}>
									$
									{String(
										advanced.variants[0].periods.find(
											(a) => a.period === "monthly",
										)?.price,
									).slice(0, -2)}
									.
									<small>
										{String(
											advanced.variants[0].periods.find(
												(a) => a.period === "monthly",
											)?.price,
										).slice(-2)}
									</small>
								</span>
								<span className="font-300 mb-[10px] text-[14px] lowercase text-blue-600">
									/{t("txt_month")}
								</span>
							</div>

							<div
								className={clsx(
									"absolute inset-0",
									"flex h-[50px] w-full flex-row items-end justify-start gap-[2px]",
									!isYearly && "top-16",
									"transition-all duration-500",
								)}>
								<span
									className={clsx(
										"font-700 text-blue-900",
										"text-[38px]",
									)}>
									$
									{String(
										yearlyPriceFormattedAdvanced,
									).slice(0, -2).length !== 0
										? String(
												yearlyPriceFormattedAdvanced,
										  ).slice(0, -2)
										: 0}
									.
									<small>
										{String(
											yearlyPriceFormattedAdvanced,
										).slice(-2)}
									</small>
								</span>
								<span className="font-300 mb-[10px] text-[14px] lowercase text-blue-600">
									/{t("txt_month")}*
								</span>
							</div>
						</div>
					</div>

					<div className="mt-8 flex w-full tablet:mt-12 desktop:mt-0">
						<Button
							gradient
							disabled={
								getAdvancedButtonText(currentPackId) ===
								"txt_current_plan"
							}
							onClick={() =>
								handlePurchaseClick(
									advanced.variants[0].pack_id,
								)
							}
							className="flex h-[52px] w-full items-center justify-center !font-500"
							text={getAdvancedButtonText(currentPackId)}
						/>
					</div>
				</div>
				<div className="z-10 h-[1px] w-full bg-blue-100 tablet:h-[259px] tablet:w-[1px] desktop:h-[1px] desktop:w-full" />
				<div className="z-10 flex flex-col gap-2 rounded-b-[8px] bg-blue-50 p-4 tablet:w-[310px] tablet:gap-4 tablet:rounded-l-none tablet:rounded-r-[8px] desktop:h-[160px] desktop:w-full desktop:gap-1 desktop:rounded-b-[8px] desktop:rounded-t-[0px]">
					{plans.advanced.points.map((point) => {
						return (
							<div
								className="flex items-center gap-[10px] "
								key={point}>
								<CustomThemedResource
									format="svg"
									source="/pricing/check"
								/>
								<span className="text-[14px] font-400 text-blue-800">
									{point}
								</span>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

interface SliderProps {
	variants: Variant[]
	isYearly: boolean
	setPackId: (pack_id: string) => void
	value: number
	setValue: (index: number) => void
}

export function SliderComponent(props: SliderProps) {
	const { variants, isYearly, setPackId, value, setValue } =
		props

	const values = variants.map((a) =>
		isYearly ? a.yearly_tokens : a.monthly_tokens,
	)

	const min = 0
	const max = values.length - 1

	const selectedPart = (value / (values.length - 1)) * 100

	let selectedPosition = `${selectedPart}%`

	if (selectedPart === 0) {
		selectedPosition = `22px`
	} else if (selectedPart !== 0 && selectedPart < 100) {
		selectedPosition = `calc(${selectedPart}% + 10px)`
	}

	return (
		<div className="my-10 flex flex-col tablet:my-10 desktop:my-0">
			<div className="relative">
				<input
					type="range"
					min={min}
					max={max}
					step={1}
					value={value}
					className="relative z-[100] w-full cursor-grab opacity-0 active:cursor-grabbing"
					onChange={(e) => {
						const newSelected = parseInt(
							e.currentTarget.value,
						)
						const variant = variants[newSelected]
						const packId = variant.pack_id

						setValue(newSelected)
						setPackId(packId)
					}}
				/>

				<div>
					<div className="absolute left-0 top-1/2 z-10 h-5 w-full -translate-y-1/2 rounded-[18px] border border-color-separator bg-color-background" />

					<div className="absolute left-0 top-1/2 z-30 h-5 w-full -translate-y-1/2 overflow-hidden rounded-[18px] p-[2px]">
						<div
							className="h-full rounded-[18px] bg-green-500 transition-all"
							style={{
								width: selectedPosition,
							}}
						/>
					</div>

					{values.map((_, index) => {
						const part = index / (values.length - 1)
						let position = `${part * 100}%`

						if (part === 0) {
							position = `13px`
						} else if (part === 1) {
							position = `calc(${part * 100}% - 13px)`
						}

						return (
							<div
								key={index}
								className={clsx(
									"absolute top-1/2 z-50 h-[4px] w-[4px] -translate-y-1/2 rounded-full transition-all",
									value === index && " scale-[2]",
									index > value
										? "bg-blue-300"
										: "bg-color-white",
								)}
								style={{
									left: position,
								}}
							/>
						)
					})}
				</div>
			</div>
			<div className="relative mt-1 h-4">
				{values.map((token, index) => {
					const part = index / (values.length - 1)
					const position = part

					const firstPoint = index === 0
					const lastPoint = index === values.length - 1
					const middlePoint = !firstPoint && !lastPoint

					return (
						<button
							key={token}
							onClick={(e) => {
								e.preventDefault()
								const variant = variants[index]
								const packId = variant.pack_id

								setValue(index)
								setPackId(packId)
							}}
							className={clsx(
								"absolute bottom-0",
								"text-[13px] transition-colors",
								middlePoint && "-translate-x-1/2",
								lastPoint && "-translate-x-full",
								value === index
									? "font-600 text-blue-800"
									: "font-500 text-blue-400",
							)}
							style={{ left: `${position * 100}%` }}>
							{token}
						</button>
					)
				})}
			</div>
		</div>
	)
}
